import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Input, Container, Spinner, Modal, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken } from '../../../helpers/jwt-token-access/accessToken'
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { BaseUrl } from "../../../helpers/Baseurl"
import axios from "axios";

const FuelGroup = [
	{ 
		label: "Vehical Type",
		options: [
			      { label: "Petrol", value: "Petrol" },
            { label: "Diesel", value: "Diesel" },
            { label: "CNG", value: "CNG" },
            { label: "Bio-Diesel", value: "Bio-Diesel" },
            { label: "LPG", value: "LPG" },
            { label: "Ethanol or Methanol", value: "Ethanol or Methanol" },
            { label: "Electric", value: "Electric" },			
		]
	}
];

class AddVehicles extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    this.state = {
      loading: false,
      brandloding:false,
      typeloading:false,
      packegeloading:false,
      breadcrumbItems: [
        { title: "Vehicles", link: "/vehicles" },
        { title: "Add New Vehicle", link: "#" },
      ],
      model_brand: false,
      model_type: false,
      model_packege:false,

      selectedLocation: { label: "Select Place", value: null },
      LocationGroup:[],
      selectedDestination: { label: "Select Destination", value: "" },
      DestinationGroup:[],

      selectedFiles:[],
      rejectedFiles:[],
      description:"",
      selectedType: "",
      selectedFuel: { label: "Petrol", value: "Petrol" },
      selectedBrandsGroup: "",
      brandGroup :"",

      selectedDestinations: [],
      PackageGroup:[],
      count:1,
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
  
    this.onPlaceInputChange = this.onPlaceInputChange.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBrandSubmit = this.handleBrandSubmit.bind(this);
    this.handleVehicleTypeSubmit = this.handleVehicleTypeSubmit.bind(this);
    this.handlePackegeTypeSubmit = this.handlePackegeTypeSubmit.bind(this);
    this.handleSelectbrandGroup = this.handleSelectbrandGroup.bind(this);
    this.handleselectedTypeGroup = this.handleselectedTypeGroup.bind(this);
    this.handleselectedFuelGroup = this.handleselectedFuelGroup.bind(this);
    this.handleSelectlocation = this.handleSelectlocation.bind(this);
    this.handleSelectDestinationGroup = this.handleSelectDestinationGroup.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.tog_type = this.tog_type.bind(this);
    this.tog_packege = this.tog_packege.bind(this);
    this.addInput = this.addInput.bind(this);
    this.removeInput = this.removeInput.bind(this);
    

  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/vehicles')
  }

  tog_center() {
    this.setState(prevState => ({
      model_brand: !prevState.model_brand
    }));
    this.removeBodyCss();
  }
  tog_type() {
    this.setState(prevState => ({
      model_type: !prevState.model_type
    }));
    this.removeBodyCss();
  }
  tog_packege() {
    this.setState(prevState => ({
      model_packege: !prevState.model_packege
    }));
    this.removeBodyCss();
  }
  
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  addInput(){
    const {count} = this.state
      this.setState({count:count+1})

  }

  removeInput(){
    const {count, selectedDestinations} = this.state
    let newdata = selectedDestinations
    newdata.pop()
    this.setState({count:count-1, selectedDestinations:newdata })

  }

  async componentDidMount() {
 
    this.loadBrandData();
    this.loadVehicleTypeData()
    this.loadDestinationData('?parent=null')
    this.loadPackageTypeData()
 }

 async loadDestinationData(filer_queryset){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.results.map(destination => {
                  options.push({ label: destination.name, value: destination.id })
                })
             
                let DestinationGroup = [
                  { 
                      label: "Destination",
                      options: options
                  }
              ];
              this.setState({ DestinationGroup:DestinationGroup  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadPackageTypeData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/vehicles/package_type/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(pkg => {
                  let lable = pkg.nights === 0 ? `${pkg.days} Day` : `${pkg.days} Days - ${pkg.nights} Nights` 
                  options.push({ label: lable, value: pkg.id })
                })
             
                let PackageGroup = [
                  { 
                      label: "Package",
                      options: options
                  }
              ];
              this.setState({ PackageGroup:PackageGroup  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadPlacesData(filer_queryset){
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.results.map(place => {
                  options.push({ label: place.name, value: place.id })
                })
            
                let LocationGroup = [
                  { 
                      label: "Places",
                      options: options
                  }
              ];
              this.setState({ LocationGroup:LocationGroup  })      
            
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
  }

  async loadBrandData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/vehicles/brand/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(comp => {
                  options.push({ label: comp.name, value: comp.id })
                })
                let selectedBrandsGroup= ""
                if (options.length >0){
                  selectedBrandsGroup = options[0]
                }else{
                  this.props.history.push("/new-brand")
                }
                let brandGroup = [
                  { 
                    label: "Brands",
                    options: options
                  }
                ];
                this.setState({ brandGroup: brandGroup,
                  selectedBrandsGroup: selectedBrandsGroup,
                
                })           
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
 }

 async loadVehicleTypeData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/vehicles/vehicle_type/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(comp => {
                options.push({ label: comp.name, value: comp.id })
              })
              let selectedType= ""
              if (options.length >0){
                selectedType = options[0]
              }
              let TypeGroup = [
                { 
                  label: "Vehical Type",
                  options: options
                }
              ];
              this.setState({ selectedType: selectedType,
                TypeGroup: TypeGroup,
              
              })           
            
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
}

handleAcceptedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ selectedFiles: files });
};

handleRejectedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ rejectedFiles : files });
} 

/**
 * Formats the size
 */
formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

  onInputChange(e){
    this.loadDestinationData(`?parent=null&search=${e}`)
  }

  onPlaceInputChange(e){
    if (this.state.selectedDestination.value)
      this.loadPlacesData(`?parent__id=${this.state.selectedDestination.value}&search=${e}`)
  }

 handleselectedTypeGroup = selectedType =>{
     this.setState({ selectedType })
 }
 handleselectedFuelGroup = selectedFuel =>{
    this.setState({ selectedFuel })
 }

  handleSelectbrandGroup = selectedBrandsGroup => {
    this.setState({ selectedBrandsGroup });
  };

  handleSelectlocation = selectedLocation => {
    this.setState({ selectedLocation  })
  };

  handleSelectDestinationGroup = selectedDestination => {
    this.loadPlacesData(`?parent__id=${selectedDestination.value}`)
    let selectedLocation = { label: "Select Place", value: null }
    this.setState({ selectedDestination, selectedLocation });
  };

  handleSelectedDestinations = (selectedStation, index) => {
    
    const {selectedDestinations} = this.state
    if(selectedDestinations.includes(selectedStation.value)){
      toastr.error(`${selectedStation.label} already selected`,"")
    }
    else{
      let newdata = selectedDestinations
      let value = selectedStation.value
      if ((newdata.length)-1 < index){
        newdata.push(value)
      }else{
          newdata[index] = value
      }
      this.setState({ selectedDestinations:newdata })
    }

  } 

  handlePackegeTypeSubmit(e, values){
    this.setState({ packegeloading: true })
    console.log(values)
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(values)
      };
      fetch(`${BaseUrl}/api/vehicles/package_type/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          console.log(data, "---data")
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ packegeloading: false })
                        }
                          
                    )
                }
                else{
                  this.loadPackageTypeData()
                  this.setState({packegeloading: false, model_packege: false })
                }    
            }
        )
  }


  handleBrandSubmit(e, values) {
    this.setState({ brandloding: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/vehicles/brand/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ brandloding: false })
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          let selectedBrandsGroup ={ label: data.name, value: data.id }
                          this.setState({brandloding: false, model_brand: false, selectedBrandsGroup:selectedBrandsGroup })
                          }
                      )
                  }    
              }
          )
  }

  handleVehicleTypeSubmit(e, values) {
    this.setState({ typeloading: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/vehicles/vehicle_type/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ typeloading: false })
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          let selectedType ={ label: data.name, value: data.id }
                          this.setState({typeloading: false, model_type: false, selectedType:selectedType })
                          }
                      )
                  }    
              }
          )
  }

  handleSubmit(e, values) {
    let description = document.getElementById("textarea").value
    // if(! this.state.selectedLocation.value){
    //   toastr.error(`Select Destination`,"") 
    // }else
    if(this.state.selectedFiles.length === 0){

      toastr.error(`Select Images`,"") 
    }else{
      this.setState({ loading: true })
      let price = []
      let on_season_price = []
      let packages = this.state.selectedDestinations
      if (packages.length === 0){
        packages = null
        price = null
        on_season_price = null
      }
      else{
        for (let i=0; i<this.state.selectedDestinations.length; i++){
          price.push(document.getElementById(`${i}`).value)
          on_season_price.push(document.getElementById(`on_season_price${i}`).value)
        }
      }      
      const formData = new FormData();
      const img = this.state.selectedFiles
      for(let i=0 ; i<img.length; i++){
        formData.append(
          "images",
          this.state.selectedFiles[i]
      );
      }
      formData.append("name",values.name)
      formData.append("model",values.model)
      formData.append("year",values.year)
      formData.append("fuel_type",this.state.selectedFuel.value)
      formData.append("vehicle_type",this.state.selectedType.value)
      formData.append("mileage",values.mileage)
      formData.append("seats",values.seates)
      formData.append("brand",this.state.selectedBrandsGroup.value)
      formData.append("place",this.state.selectedLocation.value)
      formData.append("destination",this.state.selectedDestination.value)
      formData.append("ac", document.getElementById("ac").checked)
      formData.append("heater", document.getElementById("heater").checked)
      formData.append("passenger_airbag", document.getElementById("airbags").checked)
      formData.append("number",values.number)      
      formData.append("driver_name",values.driver_name)      
      formData.append("mobile_no",values.mobile_no)      
      formData.append("agency",values.agency)   
      formData.append("agency_contact",values.agency_contact)    
      formData.append("address",values.address)      
      formData.append("zip_code",values.zip_code)              
      formData.append("description",description)
      formData.append("created_by",this.obj.user.id)

      axios.post(
        `${BaseUrl}/api/vehicles/add_vehicle/`,
        formData,
        {
            headers: {
                "Content-type": "multipart/form-data",
                "Authorization": `Bearer ${this.obj.access}`
            },                    
        }
    )
    .then(res => {
          if(packages !== null){
            let new_data = {}
            new_data["vehicle"] = res.data.id
            new_data["package"] = packages
            new_data["price"] = price
            new_data["on_season_price"] = on_season_price
            axios.post(
              `${BaseUrl}/api/vehicles/package_price/`,
              new_data,
              {
                  headers: {
                      "Content-type": "application/json",
                  },                    
              }
            ).then(newres => {

            }).catch(err => {
              console.log(err, "----------------------error");
              })
      
          }

        toastr.success(`${res.data.name} Added Successfully`,"") 
        this.props.history.push('/vehicles')
        
    })
    .catch(err => {
      toastr.error(`Somthing Went Wrong`,"") 
      this.setState({ loading: false })
        console.log(err, "----------------------error");
    })
    }
  }

  render() {
    const { TypeGroup, selectedBrandsGroup, brandGroup, selectedType, 
            selectedFuel,LocationGroup, selectedLocation,selectedDestination, DestinationGroup,PackageGroup,} = this.state;
    const CustomMenu = ({ innerRef, innerProps, isDisabled, children }) =>
        !isDisabled ? (
            <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                <Link to="#" onClick={this.tog_center}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>

            </div>
        ) : null;
    const VehicleType = ({ innerRef, innerProps, isDisabled, children }) =>
      !isDisabled ? (
          <div id="add_type" ref={innerRef} {...innerProps} classNamePrefix="customReactSelectMenu">
              {children}
              <Link to="#" onClick={this.tog_type}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
          </div>
      ) : null;
    const PackageType = ({ innerRef, innerProps, isDisabled, children }) =>
    !isDisabled ? (
        <div id="add_type" ref={innerRef} {...innerProps} classNamePrefix="customReactSelectMenu">
            {children}
            <Link to="#" onClick={this.tog_packege}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
        </div>
    ) : null;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New Vehicle" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Vehicle Detail</h4>
                      <Row>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Brand</Label>
                                    <Select 
                                        value={selectedBrandsGroup}
                                        onChange={this.handleSelectbrandGroup}
                                        options={brandGroup}
                                        components={{ Menu: CustomMenu }}
                                        classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>
                            <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="name">Vehicle Name</Label>
                              <AvField
                                name="name"
                                placeholder="Vehicle Name"
                                type="text"
                                errorMessage="Enter Vehicle Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="name"
                                
                              />
                            </div>
                          </Col> 
                        </Row>
                        <Row>
                          
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="model">Vehicle Model</Label>
                              <AvField
                                name="model"
                                placeholder="Vehicle Model"
                                type="text"
                                errorMessage="Enter Vehicle Model"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="model"
                                
                              />
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="seates">Model Year</Label>
                              <AvField
                                name="year"
                                placeholder="Model Year"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="seates"
                                
                              />
                            </div>
                          </Col>                      
                        </Row>

                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">Vehicle Type</Label>
                                <Select 
                                value={selectedType}
                                onChange={this.handleselectedTypeGroup}
                                options={TypeGroup}
                                components={{ Menu: VehicleType }}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">Fuel</Label>
                                <Select 
                                value={selectedFuel}
                                onChange={this.handleselectedFuelGroup}
                                options={FuelGroup}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="seates">No of Seates</Label>
                              <AvField
                                name="seates"
                                placeholder="No of Seates"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="seates"
                              />
                            </div>
                          </Col> 
                          
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="mileage">Mileage</Label>
                              <AvField
                                name="mileage"
                                placeholder="Mileage"
                                type="text"
                                errorMessage="Enter Vehicle Mileage"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="mileage"
                                
                              />
                            </div>
                          </Col> 
                          
                        </Row>
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="number">Vehicle Number</Label>
                                <AvField
                                  name="number"
                                  placeholder="Vehicle Number"
                                  type="text"
                                  errorMessage="Enter Vehicle Number"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="number"
                                  
                                />
                              </div>
                            </Col>
                        </Row>
                    
                        <Row>
                          <Col md={4} className="mt-3">                      
                              <div className="form-check mb-3">
                                  <Input className="form-check-input" type="checkbox" value="" id="ac" />
                                  <Label className="form-check-label" htmlFor="ac">
                                      AC
                                  </Label>
                              </div>                 
                          </Col>
                          <Col md={4} className="mt-3">                         
                              <div className="form-check mb-3">
                                  <Input className="form-check-input" type="checkbox" value="" id="heater" />
                                  <Label className="form-check-label" htmlFor="heater">
                                  Heater
                                  </Label>
                              </div>                   
                          </Col>
                          <Col md={4} className="mt-3">                         
                              <div className="form-check mb-3">
                                  <Input className="form-check-input" type="checkbox" value="" id="airbags" />
                                  <Label className="form-check-label" htmlFor="airbags">
                                      Passenger Airbags
                                  </Label>
                              </div>                   
                          </Col>
                        </Row>
                        <Row>
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="price">Description</Label>
                              <Input
                                type="textarea"
                                id="textarea"
                                rows="3"
                                placeholder="About Vehicle"
                              />
                          </div>
                        </Row>      
                    </CardBody>
                  </Card>
                </Col>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Additional Detail</h4>
                        <Row>
                          
                        <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="driver_name">Driver Name</Label>
                              <AvField
                                name="driver_name"
                                placeholder="Driver Name"
                                type="text"
                                errorMessage="Enter Driver Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="driver_name"
                                
                              />
                            </div>
                          </Col> 
                          <Col md="6">
                            <div className="mb-3">
                            <Label className="form-label " htmlFor="mobile_no">Driver Contact Number</Label>
                              <AvField
                                name="mobile_no"
                                placeholder="Driver Contact Number"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="mobile_no"
                                
                              />
                            </div>
                          </Col> 
                        </Row>
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="agency">Agency Name</Label>
                                <AvField
                                  name="agency"
                                  placeholder="Agency Name"
                                  type="text"
                                  errorMessage="Enter Agency Name"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="agency"
                                  
                                />
                              </div>
                          </Col> 
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="agency_contact">Agency Contact Number</Label>
                                <AvField
                                  name="agency_contact"
                                  placeholder="Agency Contact Number"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                      pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: "Only Numbers"
                                      }
                                  }}
                                  id="agency_contact"
                                  
                                />
                              </div>
                          </Col> 
                        </Row> 
                        <Row>
                          <Col md="12">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="address">Address</Label>
                                  <AvField
                                    name="address"
                                    placeholder="Agency Address"
                                    type="text"
                                    errorMessage="Enter Agency Address"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="address"
                                    
                                  />
                                </div>
                            </Col> 

                        </Row>
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Destination</Label>
                                  <Select 
                                  onInputChange={this.onInputChange}
                                  value={selectedDestination}
                                  onChange={this.handleSelectDestinationGroup}
                                  options={DestinationGroup}
                                  classNamePrefix="select2-selection"
                                  />
                            </div>
                          </Col>
                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Place</Label>
                                  <Select
                                  onInputChange={this.onPlaceInputChange} 
                                  value={selectedLocation}
                                  onChange={this.handleSelectlocation}
                                  options={LocationGroup}
                                  classNamePrefix="select2-selection"
                                  />

                              </div>
                              
                          </Col>
                        </Row>
                        <Row>
                          
                          <Col md="6">
                            <div className="mb-3">
                              <AvField
                                name="zip_code"
                                label="Pin Code"
                                placeholder="Enter Only number"
                                type="number"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                  
                                  maxLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be less than 7 digit"},
                                  minLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be Grater than 5 digit"}   
                                }}
                              />
                            </div>
                          </Col>                          
                        </Row>

                        <Row>
                         
                         
                        </Row>
                        {Array.from(Array(this.state.count)).map((c,  index)=> {
                          return (
                              <Row>
                                <Col md="4">
                                  <div className="mb-3">
                                      <Label className="form-label">Package</Label>
                                      <Select 
                                      onChange={(e) => this.handleSelectedDestinations(e, index)}
                                      options={PackageGroup}
                                      components={{ Menu: PackageType }}
                                      classNamePrefix="select2-selection"
                                      />

                                  </div>
                                </Col>
                                <Col md="4">
                                    <div className="mb-3">
                                      <Label className="form-label" htmlFor={index}>Off Season</Label>
                                      <AvField
                                        name="price"
                                        placeholder="Packege Price "
                                        type="text"
                                        className="form-control"
                                        id={index} 
                                      />
                                    </div>
                                  </Col> 
                                  <Col md="4">
                                    <div className="mb-3">
                                      <Label className="form-label" htmlFor={"on_season_price"+index}>On Season</Label>
                                      <AvField
                                        name="on_season_price"
                                        placeholder="Packege Price "
                                        type="text"
                                        className="form-control"
                                        id={"on_season_price"+index} 
                                      />
                                    </div>
                                  </Col> 
                              </Row>
                            )
                          })}
                    
                       
                        <Button type="button" className="btn-sm" onClick={this.addInput} color="info"><i className=" fas fa-plus"></i></Button>
                        {" "}
                        {this.state.count >1 ? <Button className="btn-sm" type="button" onClick={this.removeInput} color="danger"><i className=" fas fa-minus"></i></Button>
                        :""}
                     

                        <Row className="mt-3">
                            <Col md="12">
                            <Dropzone
                              accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                              maxSize={1000000}
                              onDrop = {(acceptedFiles, fileRejections) => {
                                this.handleRejectedFiles(fileRejections)
                                this.handleAcceptedFiles(acceptedFiles)
                                }}
                              >
                              {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                  >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                  </div>
                                  <h6>Drop only .jpeg/.png Images here or click to upload.</h6>
                                  <h6>Images size is less than 1 MB.</h6>
                                </div>
                              </div>
                              )}
                            </Dropzone>
                                <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                >
                                    {this.state.selectedFiles.map((f, i) => {
                                    return (
                                        <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                        >
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                            <Col className="col-auto">
                                                <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                                />
                                            </Col>
                                            <Col>
                                                <Link
                                                to="#"
                                                className="text-muted fw-bold"
                                                >
                                                {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                <strong>{f.formattedSize}</strong>
                                                </p>
                                            </Col>
                                            </Row>
                                        </div>
                                        </Card>
                                    );
                                    })}
                              {this.state.rejectedFiles.length > 0?
                                <>
                                  <hr></hr>
                                  <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                    {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                  </p>
                                </>
                              :""}
                               {this.state.rejectedFiles.map((f, i) => {
                            return (
                                <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-rejected_file"}
                                >
                                <div className="p-2">
                                    <Row className="align-items-center">
                                    <Col className="col-auto">
                                        <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                        />
                                    </Col>
                                    <Col>
                                        <Link
                                        to="#"
                                        className="text-muted fw-bold"
                                        >
                                        {f.name}
                                        </Link>
                                        <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                        </p>
                                    </Col>
                                    </Row>
                                </div>
                                </Card>
                              );
                              })}
                                </div>
                            </Col>
                        </Row>                 
                        <FormGroup className="mb-0 mt-2">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                            Cancel
                        </Button>
                        </div>
                          )}
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>
              </Row>
              
            </AvForm>
            {/* Models for Add Brand and Vehicle Types */}
            <Row>
              <Col sm={6} md={4} xl={3} className="mt-4">
               
                <Modal
                  isOpen={this.state.model_brand}
                  toggle={this.tog_center}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_brand: false })}>
                  Add Brand
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleBrandSubmit} >
            
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="name">Brand Name</Label>
                            <AvField
                              name="name"
                              placeholder="Brand Name"
                              type="text"
                              errorMessage="Enter Brand Name"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="name"
                              
                            />
                          </div>
                        </Col> 
                      </Row>
                                        
                      <FormGroup className="mb-0">
                        {this.state.brandloding?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>

                  </ModalBody>
                </Modal>
              </Col>
              {/* Add Vehicle Type */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_type}
                 toggle={this.tog_type}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 Add Vehicle Type
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleVehicleTypeSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name"> Name</Label>
                           <AvField
                             name="name"
                             placeholder="Vehicle Type"
                             type="text"
                             errorMessage="Enter Vehicle Type"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.typeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             {/* Add Packeges  */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_packege}
                 toggle={this.tog_packege}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_packege: false })}>
                 Add Packege Type
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handlePackegeTypeSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label" htmlFor="days"> Day</Label>
                           <AvField
                                name="days"
                                placeholder="Days"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="days"
                              />
                         </div>
                       </Col>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label" htmlFor="nights">Nights</Label>
                           <AvField
                                name="nights"
                                placeholder="Nights"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="nights"
                              />
                         </div>
                       </Col>
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.packegeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
            </Row>
            {/* End Model  */}

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddVehicles;



    